import { MapSearchIcon } from '@/components/atoms/customIcons/mapSearchIcon';
import { NatureIcon } from '@/components/atoms/customIcons/nature';
import {
  BarChart,
  Gavel,
  Groups3Outlined,
  PaidOutlined,
  ShieldOutlined,
} from '@mui/icons-material';
import { SvgIconProps } from '@mui/material';
import { ElementType } from 'react';

const getDimensionIcon = (icon: string): ElementType<SvgIconProps> => {
  switch (icon.toLowerCase()) {
    case 'mapsearchicon':
      return MapSearchIcon;
    case 'trees':
      return NatureIcon;
    case 'paidoutlined':
      return PaidOutlined;
    case 'groups3outlined':
      return Groups3Outlined;
    case 'gavel':
      return Gavel;
    case 'shieldoutlined':
      return ShieldOutlined;
    case 'barchart':
      return BarChart;
    default:
      return BarChart;
  }
};

export const icon = {
  getDimensionIcon,
};
